import { render, staticRenderFns } from "./ViewDashboard.vue?vue&type=template&id=59b0ea24&scoped=true"
import script from "./ViewDashboard.vue?vue&type=script&lang=js"
export * from "./ViewDashboard.vue?vue&type=script&lang=js"
import style0 from "./ViewDashboard.vue?vue&type=style&index=0&id=59b0ea24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b0ea24",
  null
  
)

export default component.exports